import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootLanguage, LANG } from "@/lib/i18n/lang";
import { startTranslator } from "@/lib/i18n/translator";

if (bootLanguage()) {
  if (LANG === "es") startTranslator();
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
